import CryptoJS from 'crypto-js';
import Logo from '../../assets/newStalbansLogo.png'
import { Buffer } from 'buffer';
import moment from 'moment-timezone';


const ENCRYPTION_SECRET_KEY_HEX = process.env.REACT_APP_SECRET_KEY;
export const CONNECTION_REFUSED = "connection refused";

export const printingServices = [
    'Banners',
    'Bookmarks', 
    'Book Printing', 
    'Brochures', 
    'Business Cards', 
    'Buttons', 
    'Calendars', 
    'Car Magnets', 
    'Canvas Printing & Giclee', 
    'Customized Greeting Cards', 
    'E-Journal', 
    'Event Journal', 
    'Flyers', 
    'Funeral Buttons', 
    'Journals', 
    'Logo Designing' 
]

export const memorialFuneral = {
    'wqs': 'asAS'
}

export const memorialFuneralMenus = {
    'bookMarks': 'bookmarks',
    'memorialCollege': 'memorial_collages',
    'prayerCards': 'prayer_cards',
    'memorialPosters': 'memorial_posters',
    'funeralButton': 'funeral_buttons',
    'masks': 'mask',
    'memorialTShirt': 'memorial_t_shirts',
    'thankyouCards': 'thankyou_cards',
    'gateFold': 'gate_fold',
    'gateFoldBooklet': 'gate_fold_booklet',
    'graduatedStepSmall': 'graduated_step_small',
    'indexSmall': 'index_small',
    'obituaryLargePanel': 'obituary_large_panel',
    'obituaryLargeBooklets': 'obituary_large_booklets',
    'obituaryLargeSinglefold': 'obituary_large_singlefold',
    'obituarySmallPanel': 'obituary_small_panel',
    'obituarySmallBooklets': 'obituary_small_booklets',
    'obituarySmallSinglefold': 'obituary_small_singlefold'
}

// export const decryptToken = (encryptedData) => {
//     console.log('encryptedDataencryptedDataencryptedData', encryptedData)
//     if (!encryptedData) {
//         return;
//     }
//     const [ivHex, ciphertext, originalHmac] = encryptedData.split(':');
//     const iv = CryptoJS.enc.Hex.parse(ivHex);
//     const key = CryptoJS.PBKDF2(SECRET_KEY, iv, { keySize: 256 / 32, iterations: 1000 });
//     const newHmac = CryptoJS.HmacSHA256(ciphertext, key);
//     if (originalHmac !== newHmac.toString(CryptoJS.enc.Hex)) {
//       return;
//     }
//     const decrypted = CryptoJS.AES.decrypt(ciphertext, key, { iv });
//     return decrypted.toString(CryptoJS.enc.Utf8);
// };

export const encryptToken = (token) => {
  const iv = CryptoJS.lib.WordArray.random(16);
  const key = CryptoJS.PBKDF2(ENCRYPTION_SECRET_KEY_HEX, iv, { keySize: 256 / 32, iterations: 1000 });
  const encrypted = CryptoJS.AES.encrypt(token, key, { iv });
  const hmac = CryptoJS.HmacSHA256(encrypted.toString(), key);
  return `${iv.toString(CryptoJS.enc.Hex)}:${encrypted.toString()}:${hmac.toString(CryptoJS.enc.Hex)}`;
};









// Converts hex string (64 hex chars = 32 bytes) to Uint8Array
function hexToBytes(hex) {
    const bytes = new Uint8Array(hex.length / 2);
    for (let i = 0; i < hex.length; i += 2) {
      bytes[i / 2] = parseInt(hex.substr(i, 2), 16);
    }
    return bytes;
  }
  
  async function deriveKey(secret, salt) {
    const baseKey = await window.crypto.subtle.importKey(
      'raw',
      secret,
      'PBKDF2',
      false,
      ['deriveKey']
    );
  
    return window.crypto.subtle.deriveKey(
      {
        name: 'PBKDF2',
        salt: salt,
        iterations: 200000,
        hash: 'SHA-256'
      },
      baseKey,
      {
        name: 'AES-GCM',
        length: 256
      },
      false,
      ['encrypt', 'decrypt']
    );
  }
  
  export async function encryptPayload(token) {
    const iv = window.crypto.getRandomValues(new Uint8Array(12));
    const secretBytes = hexToBytes(process.env.REACT_APP_SECRET_KEY);
    const key = await deriveKey(secretBytes, iv);
  
    const encoded = new TextEncoder().encode(token);
    const ciphertextBuffer = await window.crypto.subtle.encrypt(
      {
        name: 'AES-GCM',
        iv
      },
      key,
      encoded
    );
  
    // ciphertextBuffer = ciphertext + tag
    const ciphertext = new Uint8Array(ciphertextBuffer);
    const ct = ciphertext.slice(0, ciphertext.length - 16);
    const tag = ciphertext.slice(ciphertext.length - 16);
  
    const b64 = (arr) => btoa(String.fromCharCode(...arr));
  
    return `${b64(iv)}:${b64(ct)}:${b64(tag)}`;
  }
  
  export async function decryptToken(data) {
    try {
      const [ivB64, ctB64, tagB64] = data.split(":");
      const iv = new Uint8Array([...atob(ivB64)].map(c => c.charCodeAt(0)));
      const ct = new Uint8Array([...atob(ctB64)].map(c => c.charCodeAt(0)));
      const tag = new Uint8Array([...atob(tagB64)].map(c => c.charCodeAt(0)));
  
      const ciphertext = new Uint8Array([...ct, ...tag]);
  
      const secretBytes = hexToBytes(process.env.REACT_APP_SECRET_KEY);
      const key = await deriveKey(secretBytes, iv);
  
      const decryptedBuffer = await window.crypto.subtle.decrypt(
        {
          name: 'AES-GCM',
          iv
        },
        key,
        ciphertext
      );
  
      return new TextDecoder().decode(decryptedBuffer);
    } catch (err) {
      console.error("Decryption failed:", err);
      return null;
    }
}
  
export const getCookie = (name) => {
    try {
        const cookies = document.cookie.split('; ');
        for (const cookie of cookies) {
            const [key, value] = cookie.split('=');
            if (key === name) return decodeURIComponent(value);
        }
        return null;
    } catch (error) {
        return null;
    }
};

export const setCookie = (name, value, days) => {
    const date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    const expires = `expires=${date.toUTCString()}`;
    document.cookie = `${name}=${encodeURIComponent(value)}; ${expires}; path=/; Secure; SameSite=Strict`;
};




export const getFormattedDateLabel = (dateStr) => {
  const estDate = new Date(dateStr);  
  const now = new Date();             
  const estDateOnly = estDate.toDateString();
  const nowDateOnly = now.toDateString();
  const yesterday = new Date(now);
  yesterday.setDate(now.getDate() - 1);
  const yesterdayDateOnly = yesterday.toDateString();
  if (estDateOnly === nowDateOnly) {
    return "Today";
  } else if (estDateOnly === yesterdayDateOnly) {
    return "Yesterday";
  } else {
    return estDate.toLocaleDateString("en-US", {
      weekday: "short",
      year: "numeric",
      month: "short",
      day: "numeric",
    });
  }
};

const toYMD = (date) => {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, "0");
  const d = String(date.getDate()).padStart(2, "0");
  return `${y}-${m}-${d}`;
};

const convertEstimateDateFormat = (estimateDate, holidayDetails) => {
  console.log('\n holidayDetails', holidayDetails)
  const holidaySet = new Set(
    holidayDetails.map(h => h.holiday_date) // "YYYY-MM-DD"
  );

  if (estimateDate === 'Weekends (Saturday)') {
      // Get current date in EST
    const currentDateInEST = new Date(
      new Date().toLocaleString("en-US", { timeZone: "America/New_York" })
    );

    // Clone date to avoid mutation
    const dateObject = new Date(currentDateInEST);

    // JS: Sunday = 0, Monday = 1, ..., Saturday = 6
    const currentDay = dateObject.getDay();

    // Calculate days to add to reach Saturday
    let daysToSaturday = 6 - currentDay;

    // 👉 If today is Saturday, move to NEXT Saturday
    if (daysToSaturday === 0) {
      daysToSaturday = 7;
    }

    // Set to Saturday
    dateObject.setDate(dateObject.getDate() + daysToSaturday);

    // Format date
    const formattedDate = dateObject.toLocaleString("en-US", {
      weekday: "long",
      month: "long",
      day: "numeric",
      year: "numeric",
    });

    return formattedDate;
  } else {
    const match = estimateDate.match(/^\d+/);
    var days = match ? parseInt(match[0], 10) : 0;
    var currentOptionDay = match ? parseInt(match[0], 10) : 0;
    const currentDateInEST = new Date().toLocaleString("en-US", { timeZone: "America/New_York" });
    const [currentDate, currentTime] = currentDateInEST.split(", ");
    const [hours, minutes, meridian] = currentTime.match(/(\d+):(\d+):\d+ (\w+)/).slice(1);
    const currentHourIn24 = estimateDate === "RUSH (within 4 hours)"? meridian === "PM" && hours !== "17" ? parseInt(hours, 10) + 12 : parseInt(hours, 10) :  meridian === "PM" && hours !== "12" ? parseInt(hours, 10) + 12 : parseInt(hours, 10)
    const currentMinutes = parseInt(minutes, 10);
    const dateObjectValue = new Date(currentDateInEST);
    const dayOfWeekDate = dateObjectValue.getDay();
    if (dayOfWeekDate !== 0 && dayOfWeekDate !== 6) {
      if (currentHourIn24 >= 16 && currentHourIn24 < 24) {
        days = days + 1
      } else if (estimateDate !== 'RUSH (within 4 hours)' && currentHourIn24 > 11 && currentHourIn24 < 24) {
        days = days + 1
      } else if (currentHourIn24 === 11 && currentMinutes > 1) {
        days = days + 1
      }
    }

    const dateObject = new Date(currentDateInEST);
    var orderDays = days

    if (days === 0) {
      const dayOfWeek = dateObject.getDay();
      if (dayOfWeek === 0) {
        var sundayHoliday = 1 + days
        dateObject.setDate(dateObject.getDate() + sundayHoliday);
      } else if (dayOfWeek === 6) {
        var sundayHoliday = 2 + days
        dateObject.setDate(dateObject.getDate() + sundayHoliday);
      } else if (estimateDate !== 'RUSH (within 4 hours)') {
        // dateObject.setDate(dateObject.getDate() + days);
        while (true) {
          const dayOfWeek = dateObject.getDay();
          const dateKey = toYMD(dateObject);

          const isWeekend = dayOfWeek === 0 || dayOfWeek === 6;
          const isHoliday = holidaySet.has(dateKey);

          if (!isWeekend && !isHoliday) break;

          dateObject.setDate(dateObject.getDate() + 1);
        }
      }
    } else if (estimateDate !== 'RUSH (within 4 hours)') {
      while (days > 0) {
        dateObject.setDate(dateObject.getDate() + 1);
        const dayOfWeek = dateObject.getDay();
        if (dayOfWeek !== 0 && dayOfWeek !== 6) {
          days--;
        }
      }
    }
    var weekEndOrderDate = new Date(currentDateInEST);
    var weekday = weekEndOrderDate.getDay();
    if ((orderDays !== 0) && (weekday === 0 || weekday === 6)) {
      dateObject.setDate(dateObject.getDate() + 1);
    }
    const formattedDate = dateObject.toLocaleString("en-US", {
      weekday: "long",
      month: "long",
      day: "numeric",
      year: "numeric",
    });
    return formattedDate;
  }
}



export const exportShopDetailsProductEstimation = (selectedOptions, subTitle, slides, productPrice, productTax, productTotalPrice, holidayDetails) => {
  const now = new Date();
  const options = {
    timeZone: "America/New_York",
    year: "numeric",
    month: "long",   // "August"
    day: "numeric",  // 19
    hour12: true     // 12-hour format
  };

  const formattedDateTime = now.toLocaleString("en-US", options);

  var printTurnAround = Object.values(selectedOptions).find(
    option => option.fieldName === "print_turn_around"
  );

  // Generate HTML for selected options dynamically
  var selectedOptionsHTML = `
    <div class="field">
      <span class="label">Product Name</span> : <strong>${subTitle}</strong>
    </div>
  ` + Object.values(selectedOptions)
    .map(option => {
      return `
        <div class="field">
          <span class="label">${option.full_field_name}</span> : ${option.name || ''}
        </div>
      `;
    })
    .join('');


  if (printTurnAround) {
    const trunAroundDate = convertEstimateDateFormat(printTurnAround.name, holidayDetails);
    selectedOptionsHTML += `
      <div class="field">
        <span class="label">Turn	Around	Date</span>: ${trunAroundDate}
      </div>
    `;
  }

  const emailTemplate = `
    <!DOCTYPE html>
    <html lang="en">
    <head>
        <meta charset="UTF-8">
        <meta name="viewport" content="width=device-width, initial-scale=1.0">
        <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.5.0/css/all.min.css">
        <title>Print Estimate</title>
        <style>
            body {
                font-family: "Times New Roman", Times, serif;
                font-size: 16px;
                margin: 0;
                padding: 0;
                background: #fff;
            }

            .container {
                width: 850px;
                margin: 0 auto;
                padding: 20px;
                line-height: 1.6;
            }

            .header {
                display: flex;
                justify-content: space-between;
                align-items: flex-start;
            }

            .logo {
                width: 200px;
                margin-left: 10px;
                margin-top: 30px;
            }

            .company-info {
                text-align: right;
                font-size: 16px;
                line-height: 1.6;
                margin-right: 10px;
                margin-top: 20px;
            }

            .title {
                text-align: center;
                font-size: 19px;
                font-weight: bold;
                background: black;
                color: white;
                display: inline-block;
                padding: 5px 15px;
                margin: 5px 0;
                border-radius: 5px;
            }

            .info-section {
                margin-bottom: 15px;
                margin-left: 10px;
            }

            table {
                width: 100%;
                border-collapse: collapse;
                margin-bottom: 20px;
            }

            table,
            th,
            td {
                border: 1px solid black;
            }

            th,
            td {
                padding: 6px 8px;
                vertical-align: top;
                border-bottom: none;
            }

            th {
                background: #282828;
                text-align: center;
                color: white;
                border: 1px solid rgb(255, 255, 255);
            }

            .product-photo {
                text-align: center;
                vertical-align: middle;
                padding: 5px;
            }

            .product-photo img {
                max-width: 100%;
                max-height: 150px;
                object-fit: contain;
            }

            .subtotal {
                text-align: left;
                margin-left: 136px;
            }

            .footer {
                text-align: center;
                font-size: 16px;
                font-weight: 500;

                padding-top: 10px;
            }

            .field {
                margin-bottom: 4px;
            }

            .label {
                display: inline-block;
                min-width: 180px;
                font-weight: bold;
            }
            .price-label {
                margin-left: 17px;
            }
        </style>
    </head>
    <body>
        <div class="container">
            <!-- Header -->
            <div class="header">
                <div class="logo">
                    <img src="https://www.stalbansprinting.com/media/newStalbansLogo.png" alt="Company Logo" style="width: 90%;">
                </div>
                <div class="company-info">
                    <strong>St. Albans Digital Printing Inc.</strong><br>
                    199-12 Linden Blvd. • St. Albans, NY 11412 <i class="fa-solid fa-location-dot"></i><br>
                    orders@stalbansprinting.com <i class="fa-solid fa-envelope"></i><br>
                    www.stalbansprinting.com <i class="fa-solid fa-globe"></i><br>
                    718-528-5100 <i class="fa-solid fa-phone"></i><br>
                    718-528-5151 <i class="fa-solid fa-fax"></i>
                </div>
            </div>
            <!-- Title -->
            <div style="display: flex; align-items: center; justify-content: center; gap: 10px;">
                <hr style="flex: 1; border: 1px solid #000;">
                <div class="title">PRINT ESTIMATE</div>
                <hr style="flex: 1; border: 1px solid #000;">
            </div>
            <!-- Customer Info -->
            <div class="info-section" style="display: flex; justify-content: space-between; align-items: center;">
                <div>
                </div>
                <div style="text-align: right; margin-right: 20px;font-weight: bold;">
                    Date: ${formattedDateTime}
                </div>
            </div>
            <table>
                <thead>
                    <tr>
                        <th style="width: 5%; border: 1px solid black; border-right: 1px solid white;">Item</th>
                        <th
                            style="width: 65%; border: 1px solid black; border-right: 1px solid white; border-left: 1px solid white;">
                            Item Description</th>
                        <th style="width: 30%; border: 1px solid black; border-left: 1px solid white;">Product Photo</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td style="text-align: center;">1</td>
                        <td style="padding-left: 25px;">
                          ${selectedOptionsHTML}
                        </td>
                        <td class="product-photo">
                            <img src="${slides[0]}" alt="Product Photo" style="max-width: 100%; height: auto;">
                        </td>
                    </tr>
                    <tr>
                      <td style="border-top: none;"></td>
                      <td colspan="2" style="border-top: 1px solid #000; padding: 8px;">
                        <div style="display: flex;">
                            <div class="price-label" style="font-weight: bold;margin-top: 25px;">PRICE</div>
                            <div class="subtotal" style="text-align: left;">
                                Sub Total: $${productPrice}<br>
                                Tax: $${productTax}<br>
                                <span style="font-weight: bold;">Grand Total: $${productTotalPrice}</span>
                            </div>
                        </div>
                      </td>
                    </tr>
                </tbody>
            </table>
            <!-- Footer -->
            <div class="footer">
                Thank you for choosing St. Albans Digital Printing Inc.<br>
                <span style="font-size: 16px; padding-top: 10px; display: inline-block;">
                    <b>Call: 718-528-5100 | write to us at: orders@stalbansprinting.com</b>
                </span>
                <br>
                We are here to assist you Monday through Friday, from 10:00 am to 7:00 pm Est.
            </div>
        </div>
    </body>
    </html>
  `;
  return emailTemplate;
};


export const exportProductEstimation = (allCartDetails, formattedSubTotalAmount, formattedTax, totalPrice) => {
  const now = new Date();
  const options = {
    timeZone: "America/New_York",
    year: "numeric",
    month: "long",
    day: "numeric",
    hour12: true
  };

  const formattedDateTime = now.toLocaleString("en-US", options);

  var cartsHTML = allCartDetails
    .map((cart, index) => {
      const productSubPrice = parseFloat(cart.total_amount);
      const productTax = (productSubPrice * 8.875 / 100).toFixed(2);
      const total = (productSubPrice + parseFloat(productTax)).toFixed(2);

      let optionsHTML = `
        <div class="field">
          <span class="label">Product Name</span> : <strong>${cart.category_menu}</strong>
        </div>
      ` + (cart.cart_field_options_serializer || [])
        .map(option => {
          return `
            <div class="field">
              <span class="label">${option.field_name}</span> : ${option.option_name || ''}
            </div>
          `;
        })
        .join('');

      if (cart.turn_around_date) {
        optionsHTML += `
          <div class="field">
            <span class="label">Turn Around Date</span>: ${cart.turn_around_date}
          </div>
        `;
      }

      return `
        <tr>
          <td style="text-align: center;">${index + 1}</td>
          <td style="padding-left: 25px;">
            ${optionsHTML}
          </td>
          <td class="product-photo">
            <img src="${cart.category_menu_option_image}" alt="Product Photo" style="max-width: 100%; height: auto;">
          </td>
        </tr>
        <tr>
          <td style="border-top: none;"></td>
          <td colspan="2" style="border-top: 1px solid #000; padding: 8px;">
            <div style="display: flex;">
                <div class="price-label" style="font-weight: bold;margin-top: 25px;">PRICE</div>
                <div class="subtotal" style="text-align: left;">
                    Sub Total: $${productSubPrice}<br>
                    Tax: $${productTax}<br>
                    <span style="font-weight: bold;">Grand Total: $${total}</span>
                </div>
            </div>
          </td>
        </tr>
      `;
    })
    .join('');


  var emailTemplate = `
        <!DOCTYPE html>
    <html lang="en">
    <head>
        <meta charset="UTF-8">
        <meta name="viewport" content="width=device-width, initial-scale=1.0">
        <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.5.0/css/all.min.css">
        <title>Print Estimate</title>
        <style>
            body {
                font-family: "Times New Roman", Times, serif;
                font-size: 16px;
                margin: 0;
                padding: 0;
                background: #fff;
            }

            .container {
                width: 850px;
                margin: 0 auto;
                padding: 20px;
                line-height: 1.6;
            }

            .header {
                display: flex;
                justify-content: space-between;
                align-items: flex-start;
            }

            .logo {
                width: 200px;
                margin-left: 10px;
                margin-top: 30px;
            }

            .company-info {
                text-align: right;
                font-size: 16px;
                line-height: 1.6;
                margin-right: 10px;
                margin-top: 20px;
            }

            .title {
                text-align: center;
                font-size: 19px;
                font-weight: bold;
                background: black;
                color: white;
                display: inline-block;
                padding: 5px 15px;
                margin: 5px 0;
                border-radius: 5px;
            }

            .info-section {
                margin-bottom: 15px;
                margin-left: 10px;
            }

            table {
                width: 100%;
                border-collapse: collapse;
                margin-bottom: 20px;
            }

            table,
            th,
            td {
                border: 1px solid black;
            }

            th,
            td {
                padding: 6px 8px;
                vertical-align: top;
                border-bottom: none;
            }

            th {
                background: #282828;
                text-align: center;
                color: white;
                border: 1px solid rgb(255, 255, 255);
            }

            .product-photo {
                text-align: center;
                vertical-align: middle;
                padding: 5px;
            }

            .product-photo img {
                max-width: 100%;
                max-height: 150px;
                object-fit: contain;
            }

            .subtotal {
                text-align: left;
                margin-left: 136px;
            }

            .footer {
                text-align: center;
                font-size: 16px;
                font-weight: 500;

                padding-top: 10px;
            }

            .field {
                margin-bottom: 4px;
            }

            .label {
                display: inline-block;
                min-width: 180px;
                font-weight: bold;
            }
            .price-label {
                margin-left: 17px;
            }
        </style>
    </head>
    <body>
        <div class="container">
            <!-- Header -->
            <div class="header">
                <div class="logo">
                    <img src="https://www.stalbansprinting.com/media/newStalbansLogo.png" alt="Company Logo" style="width: 90%;">
                </div>
                <div class="company-info">
                    <strong>St. Albans Digital Printing Inc.</strong><br>
                    199-12 Linden Blvd. • St. Albans, NY 11412 <i class="fa-solid fa-location-dot"></i><br>
                    orders@stalbansprinting.com <i class="fa-solid fa-envelope"></i><br>
                    www.stalbansprinting.com <i class="fa-solid fa-globe"></i><br>
                    718-528-5100 <i class="fa-solid fa-phone"></i><br>
                    718-528-5151 <i class="fa-solid fa-fax"></i>
                </div>
            </div>
            <!-- Title -->
            <div style="display: flex; align-items: center; justify-content: center; gap: 10px;">
                <hr style="flex: 1; border: 1px solid #000;">
                <div class="title" style='border-radius: 5px !important;'>PRINT ESTIMATE</div>
                <hr style="flex: 1; border: 1px solid #000;">
            </div>
            <!-- Customer Info -->
            <div class="info-section" style="display: flex; justify-content: space-between; align-items: center;">
                <div>
                </div>
                <div style="text-align: right; margin-right: 20px;font-weight: bold;">
                    Date: ${formattedDateTime}
                </div>
            </div>
            <table>
                <thead>
                    <tr>
                        <th style="width: 5%; border: 1px solid black; border-right: 1px solid white;">Item</th>
                        <th
                            style="width: 65%; border: 1px solid black; border-right: 1px solid white; border-left: 1px solid white;">
                            Item Description</th>
                        <th style="width: 30%; border: 1px solid black; border-left: 1px solid white;">Product Photo</th>
                    </tr>
                </thead>
                <tbody>
                  ${cartsHTML}
                </tbody>
            </table>
            <!-- Footer -->
            <div class="footer">
                Thank you for choosing St. Albans Digital Printing Inc.<br>
                <span style="font-size: 16px; padding-top: 10px; display: inline-block;">
                    <b>Call: 718-528-5100 | write to us at: orders@stalbansprinting.com</b>
                </span>
                <br>
                We are here to assist you Monday through Friday, from 10:00 am to 7:00 pm Est.
            </div>
        </div>
    </body>
    </html>
  `
  return emailTemplate;
};



function capitalize(str) {
    return str ? str.charAt(0).toUpperCase() + str.slice(1).toLowerCase() : '';
}

const getQuantity = (options) => {
    const quantityOption = options.find(opt => opt.field_name.toLowerCase() === 'quantity');
    return quantityOption ? quantityOption.option_name : 'N/A';
};

export const paymentMode = {
  'cash': 'Cash',
  'check': 'Check',
  'credit_card': 'Credit Card'
}

export const exportOfflineOrder = (orderDetails) => {
    const paymentType = paymentMode[ orderDetails.payment_type];
    let cartTemplate = '';
    orderDetails.carts.forEach((cart ,index) => {
        cartTemplate += `
            <tr>
                <td>${index+1}</td>
                <td>${cart.category_menu_option.category_name}</td>
                <td style="text-align: center;">
                <img src="${cart.category_menu_option.image_file}" style="max-width:100px; height:auto;">
                </td>
                <td>$${cart.price}</td>
                <td>$${cart.price}</td>
            </tr>
        `;
    });

    const orderTemplate = `
        <!DOCTYPE html>
        <html lang="en">
        <head>
        <meta charset="UTF-8">
        <title>Invoice</title>
        <style>
            body {
                font-family: 'Times New Roman', serif;
                padding: 60px!important;
                max-width: 800px;
                margin: auto;
                color: #000;
            }
            .header {
                display: flex;
                justify-content: space-between;
                align-items: center;
            }
            .logo {
                width: 150px;
                display: block;
                margin: 0 auto;
            }
            .company-info {
                text-align: left;
                margin-top: 25px;
                margin-left: 260px;
            }
            h2 {
                margin-top: 20px;
                margin-bottom: 10px;
            }
            table {
                width: 100%;
                border-collapse: collapse;
                margin-top: 15px;
            }
            table, th, td {
                border: 1px solid black;
            }
            th, td {
                padding: 8px;
                text-align: left;
            }
            .right {
                text-align: right;
            }
            .no-border {
                border: none;
            }
            .footer {
                margin-top: 40px;
                text-align: center;
                font-size: 17px;
                line-height: 1.8;
            }
            .bold {
                font-weight: bold;
            }
            .billing-row {
                display: flex;
                justify-content: space-between;
                align-items: flex-start;
                line-height: 1.5;
            }
            .bill-to,
            .company-info {
                width: 48%;
            }
            @media print {
                @page {
                    size: A4;
                    margin: 20mm;
                }
                body {
                    max-width: 100%;
                    margin: 0;
                    padding: 0;
                
                }
                .no-print {
                    display: none;
                }
            }
        </style>
        <script>
            function downloadPDF() {
                const element = document.body;
                html2pdf().from(element).save('invoice.pdf');
            }
        </script>
        <script src="https://cdnjs.cloudflare.com/ajax/libs/html2pdf.js/0.10.1/html2pdf.bundle.min.js"></script>
        </head>
        <body>

        <div class="header">
            <img src="https://www.stalbansprinting.com/media/newStalbansLogo.png" class="logo" alt="Logo"> 
        </div><br>
        
        <div class="billing-row">
            <div class="bill-to">
            <p><strong>Bill To:</strong><br>
                ${capitalize(orderDetails.address)}<br>
                ${capitalize(orderDetails.city)}, ${orderDetails.state.toUpperCase()}<br>
                US, ${orderDetails.zip_code}<br>
            </p>
            </div>
            <div class="company-info">
            <strong>Order id:</strong> ${orderDetails.unique_order_id} <br>
            <strong>Payment Mode:</strong> ${paymentType} <br>
            <strong>Date:</strong> ${moment.utc(orderDetails.created_at).tz('America/New_York').format('dddd, MMMM D, YYYY HH:mm:ss')}
            </div>
        </div>
        
        <h2 style="text-align: center;">Print Estimate</h2>

        <table>
            <thead>
            <tr>
                <th>#Item</th>
                <th>Category</th>
                <th>Image</th>
                <th>Price</th>
                <th>Ext Price</th>
            </tr>
            </thead>
            <tbody>
            ${cartTemplate}
            <tr>
                <td colspan="3" class="no-border"></td>
                <td class="bold">Sub Total</td>
                <td class="bold">$${orderDetails.sub_price}</td>
            </tr>
            <tr>
                <td colspan="3" class="no-border"></td>
                <td class="bold">Tax (8.875%)</td>
                <td class="bold">$${orderDetails.tax}</td>
            </tr>
            <tr>
                <td colspan="3" class="no-border"></td>
                <td class="bold">Grand Total</td>
                <td class="bold">$${orderDetails.total_price}</td>
            </tr>
            <tr>
                <td colspan="3" class="no-border"></td>
                <td class="bold">Deposit Balance</td>
                <td class="bold">-$${parseFloat(orderDetails.deposit_price).toFixed(2)}</td>
            </tr>
            <tr>
                <td colspan="3" class="no-border"></td>
                <td class="bold">Balance Due</td>
                <td class="bold">$${orderDetails.balance_due}</td>
            </tr>
            </tbody>
        </table>

        <div class="footer">
            Thank you for your business, St.Albans Printing!<br>
            Our daily pickups are available Monday through Friday, starting at 5:00 PM onwards.<br>
            Visit us online at www.stalbansprinting.com
        </div>
        </body>
        </html>
    `;
    return orderTemplate;
};

export const getImageSizeByBlob = async (imageUrl) => {
    try {
        const response = await fetch(imageUrl);
        const blob = await response.blob();
        const sizeInBytes = blob.size;
        const sizeInKB = (sizeInBytes / 1024).toFixed(2);
        const sizeInMB = (sizeInBytes / (1024 * 1024)).toFixed(2);
        return { bytes: sizeInBytes, kb: sizeInKB, mb: sizeInMB };
    } catch (error) {
        console.error("Error getting image size:", error);
        return { bytes: 0, kb: "0.00", mb: "0.00" };
    }
};

export const seoMetaData = {
  'bookmarks': {
    title: "Personalized Bookmarks for Funeral | St. Albans Digital Printing Inc",
    description: "Order high-quality laminated bookmarks with your choice of gloss or matte finishes from St. Albans Digital Printing. Select from a variety of paper types, including premium options specifically designed for memorial, obituary, and funeral bookmarks. Personalize your bookmarks with custom artwork, elegant finishes, and rounded corners to create a unique tribute. Enjoy fast turnaround times and expert design support. Call 718-528-5100 today to get started!",
    keywords: "custom laminated bookmarks, memorial bookmarks, obituary bookmarks, funeral bookmarks, personalized bookmarks, high-quality printing, premium paper bookmarks, gloss finish bookmarks, matte finish bookmarks, soft touch lamination, keepsake bookmarks, tribute bookmarks, professional bookmark design, affordable bookmark printing, St. Albans Digital Printing",
    link: "https://www.stalbansprinting.com/bookmarks"
  },
  'funeral_buttons': {
    title: "Funeral Memorial Buttons In Queens |St. Albans Digital Printing Inc",
    description: "Honor your loved one's memory with our customized funeral memorial buttons. Perfect for funerals, memorial services, and special occasions, these high-quality buttons feature vibrant photo prints and personalized designs. Contact St. Albans Digital Printing at (718) 528-5100 to create your unique tribute.",
    keywords: "funeral memorial buttons, personalized funeral badges, custom memorial buttons, photo printed funeral badges, funeral keepsakes, remembrance buttons, memorial service badges, St. Albans Digital Printing",
    link: "https://www.stalbansprinting.com/funeral_buttons"
  },
  'gatefold': {
    title: "Gatefold Programs in Queens| St. Albans Digital Printing Inc",
    description: "Honor your loved one with our custom gatefold memorial programs. These unique designs unfold to reveal heartfelt messages and cherished photos, creating a beautiful keepsake that celebrates their life. Available in various sizes, our programs are easy to customize to reflect the essence of your loved one. Contact St. Albans Digital Printing at 718-528-5100 to design your memorial program today.",
    keywords: "gatefold memorial programs, custom funeral programs, personalized memorial programs, unique funeral keepsakes, heartfelt tribute programs, memorial service materials, customizable gatefold programs, St. Albans Digital Printing",
    link: "https://www.stalbansprinting.com/gatefold"
  },
  'gatefold_booklet': {
    title: "Funeral Gate fold programs in Queens | St. Albans Digital Printing Inc",
    description: "Discover our elegant gatefold booklets, a unique way to present your loved one's memorial program. Fully customizable, these booklets feature a centerfold that opens to reveal a spacious interior for displaying photographs, obituaries, and ceremony details. Perfect for honoring life stories, our high-quality funeral programs are designed to provide a beautiful tribute. Call 718-528-5100 today to get started!",
    keywords: "gatefold booklets, memorial programs, funeral service programs, customizable memorials, obituary booklets, celebration of life, high-quality funeral printing, personalized funeral programs, memorial ceremony outlines, elegant funeral booklets, St. Albans Digital Printing",
    link: "https://www.stalbansprinting.com/gatefold_booklet"
  },
  'index_small': {
    title: "Index Funeral Program | St. Albans Digital Printing Inc",
    description: "Honor your loved ones with our personalized funeral programs. These printed documents provide a meaningful tribute, detailing the service schedule and summarizing the life achievements of the deceased. Collaborate with us or create independently to craft a dignified farewell. Contact St. Albans Digital Printing at 718-528-5100 to order your custom program.",
    keywords: "funeral programs, memorial service programs, personalized memorial programs, custom funeral brochures, tribute to the deceased, life achievements summary, funeral service details, index funeral programs, St. Albans Digital Printing",
    link: "https://www.stalbansprinting.com/index_small"
  },
  'obituary_large_3_panel': {
    title: "Large 3 Panel Funeral Programs in Queens, NewYork | St. Albans Digital Printing Inc",
    description: "Celebrate your loved one's legacy with our large 3-panel funeral programs, printed on legal-size paper in Brooklyn, New York. These elegant programs provide ample space for the Order of Service, Favorite Memories, Special Tributes, and cherished photos. Customizable to reflect the essence of your loved one, our programs are perfect for memorial services. Contact St. Albans Digital Printing at 718-528-5100 to create a meaningful tribute today.",
    keywords: "large 3-panel funeral programs, custom funeral programs Brooklyn, memorial service programs, order of service details, personalized memorial tributes, funeral keepsakes, heartfelt memorials, St. Albans Digital Printing, funeral ceremony outlines",
    link: "https://www.stalbansprinting.com/obituary_large_3_panel"
  },
  'obituary_large_booklets': {
    title: "Obituary Booklets Printing In New York City | St. Albans Digital Printing Inc",
    description: "Create personalized funeral program booklets with St. Albans Digital Printing. Our custom memorial booklets serve as cherished keepsakes, featuring photos, heartfelt messages, and detailed life stories to honor your loved one's legacy. Contact us at 718-528-5100 for compassionate service and premium printing.",
    keywords: "funeral program booklets, memorial booklets, obituary printing, funeral service programs, custom funeral programs, personalized memorial booklets, order of service booklets, celebration of life programs, funeral keepsakes, St. Albans Digital Printing",
    link: "https://www.stalbansprinting.com/obituary_large_booklets"
  },
  'obituary_large_singlefold': {
    title: "Large Single Fold Funeral Program | St. Albans Digital Printing Inc",
    description: "Create high-quality funeral programs that include the order of service, obituary, and photographs of your loved one. Our fully customizable memorial programs feature elegant layouts and backgrounds, perfect for honoring their life and legacy. Contact St. Albans Digital Printing at 718-528-5100 to order your personalized funeral program.",
    keywords: "funeral programs, memorial service programs, order of service programs, obituary programs, custom funeral brochures, personalized memorial programs,Large Single Fold Funeral Program, tribute to the deceased, St. Albans Digital Printing",
    link: "https://www.stalbansprinting.com/obituary_large_singlefold"
  },
  'obituary_letter_size_3_panel': {
    title: "Letter Size Funeral Programs in New York City | St. Albans Digital Printing Inc",
    description: "Honor your loved one with our customizable letter size funeral programs in New York City. These elegant programs provide ample space for the order of service, obituary, and cherished photos, making them perfect for memorial services. Contact St. Albans Digital Printing at 718-528-5100 to create a meaningful tribute today.",
    keywords: "letter size funeral programs, custom funeral programs NYC, memorial service programs, personalized funeral tributes, order of service details, obituary programs, high-quality funeral keepsakes, St. Albans Digital Printing",
    link: "https://www.stalbansprinting.com/obituary_letter_size_3_panel"
  },
  'obituary_small_3_panel': {
    title: "Trifold Funeral Service Brochure | St. Albans Digital Printing Inc",
    description: "Create a personalized tri-fold funeral program with St. Albans Digital Printing. Our compact, pocket-sized memorial brochures feature the order of service, hymns, readings, personal messages, and photos, providing a meaningful keepsake to honor your loved one's life. Contact us at 718-528-5100 to design a custom tribute.",
    keywords: "tri-fold funeral program, small 3-panel funeral brochure, compact memorial pamphlet, personalized funeral service program, pocket-sized obituary template, custom funeral order of service, memorial keepsake design, St. Albans Digital Printing",
    link: "https://www.stalbansprinting.com/obituary_small_3_panel"
  },
  'funeral_program_mega_3_panel': {
    title: "Mega 3-Panel Funeral Programs | St. Albans Digital Printing Inc",
    description: `Honor your loved one with our Mega 3-Panel Funeral Programs, printed on legal-size (12" x 25") paper. This elegant program provides ample space for detailed obituaries, heartfelt tributes, and cherished memories. Customize the order of service and include photos to celebrate their legacy. Contact St. Albans Digital Printing at 718-528-5100 to create your personalized program.`,
    keywords: "tri-fold funeral program, small 3-panel funeral brochure, compact memorial pamphlet, personalized funeral service program, pocket-sized obituary template, custom funeral order of service, memorial keepsake design, St. Albans Digital Printing",
    link: "https://www.stalbansprinting.com/funeral_program_mega_3_panel"
  },
  'obituary_small_booklets': {
    title: "Small Funeral Booklet Printing In New York | St. Albans Digital Printing Inc",
    description: "Create a lasting tribute with our unique small funeral booklets, measuring 5.5 x 8.5 inches, in New York City. These elegant keepsakes are perfect for showcasing heartfelt photos, meaningful messages, and cherished memories. Choose from various templates or design your own to honor your loved one's legacy. Contact St. Albans Digital Printing at 718-528-5100 to start your order today.",
    keywords: "small funeral booklets, custom funeral booklets NYC, personalized memorial booklets, keepsake funeral programs, memorial ceremony outlines, order of service details, high-quality funeral printing, St. Albans Digital Printing",
    link: "https://www.stalbansprinting.com/obituary_small_booklets"
  },
  'obituary_small_singlefold': {
    title: "Small Bi-fold Program Printing In New York | St. Albans Digital Printing Inc",
    description: "Create a personalized small single fold funeral program to honor your loved one's memory. Our compact and elegant memorial service brochures feature a cover photo, name, dates, and a brief message, providing a meaningful keepsake for attendees. Contact St. Albans Digital Printing at 718-528-5100 to design a custom funeral program that celebrates your loved one's life.",
    keywords: "small single fold funeral program, compact memorial service brochure, personalized funeral program, custom funeral service pamphlet, pocket-sized obituary program, memorial keepsake design, St. Albans Digital Printing",
    link: "https://www.stalbansprinting.com/obituary_small_singlefold"
  },
  'funeral_square_booklets': {
    title: "Square Booklet Printing in Queens| St. Albans Digital Printing Inc",
    description: "Honor your loved one's memory with our custom square funeral booklets, measuring 8.5 x 8.5 inches. These elegant booklets are perfect for showcasing heartfelt photos, meaningful messages, and cherished memories. Create a beautiful keepsake that reflects their life and legacy. Contact St. Albans Digital Printing at 718-528-5100 to design your personalized booklet.",
    keywords: "square booklets, custom funeral booklets, memorial booklets, personalized memorial programs, tribute booklets, funeral service materials, heartfelt memorials, St. Albans Digital Printing",
    link: "https://www.stalbansprinting.com/funeral_square_booklets"
  },
  'graduated_step_programs': {
    title: "Graduated Step Funeral Programs | St. Albans Digital Printing Inc",
    description: "Create a heartfelt tribute with our Graduated Step Funeral Programs, designed to guide attendees through the memorial service. These elegant programs feature an organized layout that includes the order of service, obituary, and a collage page for cherished photos. Customize your program easily with our user-friendly online tools. Contact St. Albans Digital Printing today to honor your loved one with a beautiful memorial program.",
    keywords: "Graduated Step Funeral Programs, Step Fold Funeral Program, memorial service documents, order of service programs, personalized funeral tributes, funeral program collage, custom memorial programs, funeral ceremony outlines, St. Albans Digital Printing",
    link: "https://www.stalbansprinting.com/graduated_step_programs"
  },
  'mask': {
    title: "Printed Face Masks in New York |St. Albans Digital Printing Inc",
    description: "Honor your loved one's memory with our custom funeral face masks. Our reusable and comfortable masks are available in various sizes, providing a unique and practical tribute for funerals and memorial services. Contact St. Albans Digital Printing at 718-528-5100 to design a personalized memorial face covering.",
    keywords: "personalized funeral face masks, custom memorial face coverings, reusable funeral masks, comfortable memorial masks, funeral service face masks, custom funeral masks, St. Albans Digital Printing",
    link: "https://www.stalbansprinting.com/mask"
  },
  'memorial_collages': {
    title: "Memorial Collage For Funeral| St. Albans Digital Printing Inc",
    description: "Create beautiful custom funeral memorial collages to honor your loved one's life. Our collages showcase heartfelt photos, meaningful messages, and cherished memories, perfect for memorial services. Enhance your tribute with our range of personalized memorial products, including prayer cards, bookmarks, and keepsakes. Contact St. Albans Digital Printing at 718-528-5100 to start designing your memorial collage today.",
    keywords: "funeral memorial collages, custom memorial collages, personalized funeral products, tribute collages, memorial photo displays, funeral keepsakes, celebration of life collages, obituary collages, St. Albans Digital Printing",
    link: "https://www.stalbansprinting.com/memorial_collages"
  },
  'memorial_fans': {
    title: "Custom Memorial Fans NYC | St. Albans Digital  Printing Inc",
    description: "Honor your loved one with custom memorial fans from St. Albans Digital Printing Inc in NYC. Personalized with photos, quotes & life stories. A comforting keepsake for family & friends. Call 718-528-5100",
    keywords: "funeral program fans, memorial fans, custom funeral fans, personalized fans, memorial keepsakes, funeral programs, NYC printing services, St. Albans Digital Printing Inc, celebration of life, In Loving Memory",
    link: "https://www.stalbansprinting.com/memorial_fans"
  },
  'memorial_posters': {
    title: "Custom Funeral Memorial Posters | St. Albans Digital Printing Inc",
    description: "Honor your loved ones with custom funeral memorial posters from St. Albans Digital Printing Inc. These beautifully designed posters allow you to showcase personal photos, heartfelt quotes, and meaningful messages. Ideal for memorial services, they serve as a touching tribute to the departed. Contact us at 718-528-5100 for help in creating your personalized memorial poster today!",
    keywords: "funeral memorial posters, custom funeral posters, personalized tribute posters, memorial service posters, remembrance posters, high-quality photo posters, celebration of life signs, St. Albans Digital Printing, funeral program templates",
    link: "https://www.stalbansprinting.com/memorial_posters"
  },
  'memorial_t_shirts': {
    title: "Custom T Shirts For Funeral |St. Albans Digital Printing Inc",
    description: "Create heartfelt personalized memorial T-shirts for funerals, memorial services, family gatherings, and remembrance events. Our custom shirts provide comfort and unity while honoring your loved one's legacy. Contact St. Albans Digital Printing at 718-528-5100 to design your tribute.",
    keywords: "personalized memorial T-shirts, custom funeral shirts, memorial service T-shirts, remembrance shirts, funeral keepsakes, family reunion shirts, custom tribute t-shirts, St. Albans Digital Printing",
    link: "https://www.stalbansprinting.com/memorial_t_shirts"
  },
  'prayer_cards': {
    title: "Custom Funeral Memorial Prayer Cards in Brooklyn | St. Albans Digital Printing Inc",
    description: "Honor your loved ones with our custom funeral memorial prayer cards, designed to provide comfort and solace. These beautiful keepsakes can be personalized with cherished photos, heartfelt prayers, and meaningful messages. Perfect for funerals, memorial services, weddings, and baptisms. Contact St. Albans Digital Printing at (718) 528-5100 to create your lasting tribute today.",
    keywords: "custom funeral memorial prayer cards, personalized prayer cards, keepsake prayer cards, memorial service cards, funeral remembrance cards, custom-designed prayer cards, Brooklyn prayer cards, heartfelt memorials, St. Albans Digital Printing",
    link: "https://www.stalbansprinting.com/prayer_cards"
  },
  'thankyou_cards': {
    title: "Thank You Cards In Queens, New York | St. Albans Digital Printing Inc",
    description: "Elevate your expressions of gratitude with personalized thank-you cards from St. Albans Digital Printing Inc. Our stunning designs and premium printing techniques create memorable keepsakes for any occasion. Whether celebrating a special event or acknowledging a kind gesture, our custom thank-you cards allow you to convey appreciation in an elegant way. Call us at (718) 528-5100 to place your order today!",
    keywords: "personalized thank-you cards, custom thank-you cards, premium printing services, gratitude cards, elegant thank-you notes, St. Albans Digital Printing, custom greeting cards",
    link: "https://www.stalbansprinting.com/thankyou_cards"
  },
  'video_tributes': {
    title: "Video Editing Service In New York City | St. Albans Digital Printing Inc",
    description: "Create a beautiful memorial video tribute with St. Albans Printing in NYC. Personalized tributes with music, photos & more. Fast turnaround & 100% satisfaction guaranteed. Call 718-528-5100!",
    keywords: "video tributes, memorial video, funeral video, tribute video, memorial slideshow, video editing, NYC video services, St. Albans Digital Printing, personalized tributes, heartfelt tributes,video editing NYC",
    link: "https://www.stalbansprinting.com/video_tributes"
  },
  'banner': {
    title: "Banner Printing In New York City | St. Albans Digital Printing Inc",
    description: "At St. Albans Digital Printing Inc., we specialize in high-quality custom banners tailored for any occasion. Our lightweight and portable banners are perfect for promoting brands, celebrating events, or conveying messages. With over 30 years of experience, we offer fast turnaround times, including same-day service, and a variety of sizes and designs to meet your needs. Call us at (718) 528-5100 to create your personalized banner today!",
    keywords: "custom banners, personalized banners, promotional banners, event banners, wedding banners, trade show banners, outdoor banners, indoor banners, St. Albans Digital Printing, high-quality printing",
    link: "https://www.stalbansprinting.com/banner"
  },
  'marketing_essentials_bookmarks': {
    title: "Custom Marketing Bookmarks | St. Albans Digital Printing Inc.",
    description: "Promote your brand effectively with custom marketing bookmarks from St. Albans Digital Printing Inc. Our bookmarks serve as powerful advertising tools, ensuring your message stays top-of-mind for customers. With vibrant colors and eye-catching designs, our bookmarks help establish strong brand recognition. Call us at (718) 528-5100 to create your personalized bookmarks today!",
    keywords: "custom bookmarks, promotional bookmarks, marketing tools, personalized bookmarks, high-quality printing, vibrant color bookmarks, durable bookmarks, business marketing materials, St. Albans Digital Printing",
    link: "https://www.stalbansprinting.com/marketing_essentials_bookmarks"
  },
  'buckslips': {
    title: "Custom Printed Buckslips | St. Albans Digital Printing Inc.",
    description: "St. Albans Digital Printing Inc. specializes in high-quality custom buck slips that serve as effective marketing tools. Ideal for direct mail campaigns, our buck slips function as statement stuffers to promote new products, special offers, and services. With vibrant full-color printing and premium gloss or matte finishes, these lightweight inserts ensure your message stands out without increasing postage costs. Enjoy fast turnaround times and expert support—order your custom buck slips today!",
    keywords: "custom buck slips, statement stuffers, promotional inserts, direct mail marketing, lightweight marketing tools, cost-effective printing solutions, full-color printing, business marketing materials, St. Albans Digital Printing",
    link: "https://www.stalbansprinting.com/buckslips"
  },
  'car_magnet': {
    title: "Custom Magnetic Signs NYC| St. Albans Digital Printing Inc.",
    description: "Transform your vehicle into a mobile billboard with premium custom car magnets from St. Albans Digital Printing Inc. Our high-quality magnetic signs are designed for maximum visibility and durability, featuring vibrant full-color printing and a protective UV coating. Perfect for businesses, events, and promotions, these easy-to-apply magnets come in various sizes and shapes to fit your needs. Order today to enhance your brand's visibility on the road!",
    keywords: "custom car magnets, vehicle magnets, magnetic signs, mobile advertising, promotional car signs, business car magnets, event marketing tools, high-quality magnetic material, UV-coated car magnets, St. Albans Digital Printing",
    link: "https://www.stalbansprinting.com/car_magnet"
  },
  'envelopes': {
    title: "Envelopes Printing In New York| St. Albans Digital Printing Inc.",
    description: "St. Albans Digital Printing Inc. offers premium custom envelope printing to elevate your correspondence. Our envelopes are perfect for business letters, invitations, and special announcements. Crafted from high-quality materials with options for glossy, matte, and UV coatings, they ensure a professional look that captures attention. Customize your envelopes with logos and unique designs to enhance brand recognition. Contact us today for fast turnaround times and exceptional service!",
    keywords: "custom envelopes, envelope printing, business envelopes, promotional envelopes, high-quality printing, personalized envelopes, direct mail solutions, Queens NY printing services, marketing materials, St. Albans Digital Printing",
    link: "https://www.stalbansprinting.com/envelopes"
  },
  'gift_certificate': {
    title: "Custom Gift Certificates Printing in New York | St. Albans Digital Printing Inc.",
    description: "Delight your loved ones with custom gift certificates from St. Albans Digital Printing Inc. Our personalized gift certificates are perfect for any occasion, including birthdays and holidays. Choose from a variety of sizes and finishes to match your brand's style. We ensure a quick turnaround without compromising quality. Elevate your gift-giving experience with high-quality gift certificates that create lasting memories!",
    keywords: "custom gift certificates, gift certificate printing, personalized gifts, business printing services, high-quality printing, fast production times, memorable gift experiences, brand loyalty, St. Albans Digital Printing",
    link: "https://www.stalbansprinting.com/gift_certificate"
  },
  'menus': {
    title: "Custom Restaurant Menu Printing in New York | St. Albans Digital Printing Inc.",
    description: "Elevate your dining experience with custom restaurant menus from St. Albans Digital Printing Inc. Our premium menus are designed to captivate customers and enhance your brand's presentation. Available in various sizes, our menus feature durable materials and customizable finishes, including glossy, matte, and uncoated options. Perfect for restaurants, cafés, and bars, our high-quality printing ensures vibrant colors that make a lasting impression. Partner with us today for exceptional menu printing services!",
    keywords: "custom restaurant menus, menu printing, high-quality menus, laminated menus, eco-friendly disposable menus, takeout menus, professional presentation, restaurant marketing materials, St. Albans Digital Printing",
    link: "https://www.stalbansprinting.com/menus"
  },
  'photo_coffee_mug': {
    title: "Personalized Photo Mugs In New York City | St. Albans Digital Printing Inc.",
    description: "Get your custom ceramic mugs printed the same day with St. Albans Digital Printing Inc. Our mugs are perfect for personal use, corporate gifts, and special occasions. With options for front print and wraparound designs, you can showcase your creativity by adding personal photos, company logos, or unique messages. Enjoy high-quality photo printing, no setup fees, and fast delivery right to your doorstep. Order today and elevate your beverage experience with personalized mugs that make a statement!",
    keywords: "same day ceramic mug printing, custom coffee mugs, personalized mugs, corporate gifts, promotional mugs, high-quality printing, wraparound mug design, St. Albans Digital Printing",
    link: "https://www.stalbansprinting.com/photo_coffee_mug"
  },
  'product_labels': {
    title: "Custom Label Printing Services in NYC | St. Albans Digital Printing Inc.",
    description: "St. Albans Digital Printing Inc. is New York City's premier custom label printing service, offering high-quality labels for product packaging, shipping, and branding since 1965. Our expert team will guide you through the entire design process to create specialty labels that make a lasting impression. From barcode labels to custom package stickers, we provide a variety of shapes, sizes, and finishes tailored to your business needs. Contact us today to elevate your packaging with our premium label solutions!",
    keywords: "custom label printing, NYC label printing, specialty labels, product packaging labels, shipping labels, barcode labels, marketing stickers, package seals, Best printing services, St Albans Digital Printing Inc",
    link: "https://www.stalbansprinting.com/product_labels"
  },
  'tickets': {
    title: "Ticket Printing Company Queens Ny | St. Albans Digital Printing Inc.",
    description: "Create unforgettable event experiences with custom printed tickets from St. Albans Digital Printing Inc. Perfect for festivals, concerts, sports events, and fundraisers, our tickets feature a clean design and advanced fraud prevention features like holographic foils and serial numbers. Choose from classic, full-color, or mini ticket options, all customizable to reflect your brand. Order today for fast turnaround and high-quality printing that makes a lasting impression!",
    keywords: "custom event tickets, ticket printing services, classic tickets, full-color tickets, mini tickets, event branding, St. Albans Digital Printing, NYC ticket printing",
    link: "https://www.stalbansprinting.com/tickets"
  },
  'beer_labels': {
    title: "BeerLabel Printing Company In Queens | St. Albans Digital Printing Inc.",
    description: "St. Albans Digital Printing Inc. specializes in high-quality custom beer label printing for bottles, cans, growlers, and tap handles. Our durable labels are moisture-resistant, ensuring your branding stays vibrant and intact. Choose from a variety of materials, finishes, and custom sizes to create labels that make your beer stand out. Whether you need White BOPP, Clear BOPP, Vinyl, or Holographic labels, we provide premium solutions tailored to your brewery’s needs. Contact us today for expert beer label printing services!",
    keywords: "custom beer labels, beer label printing, brewery labels, bottle labels, can labels, growler labels, waterproof beer labels, custom beverage labels, St Albans Digital Printing Inc",
    link: "https://www.stalbansprinting.com/beer_labels"
  },
  'bottle_labels': {
    title: "Bottle Label Printing In Newyork | St. Albans Digital Printing Inc.",
    description: "St. Albans Digital Printing Inc. specializes in same-day custom bottle label printing for water bottles, wine, beer, juice, supplements, cosmetics, and more. Our high-quality labels are available in waterproof, oil-resistant, and freezer-safe materials with various adhesive options. Choose from clear, matte, gloss, or specialty finishes, including white ink on transparent backgrounds. Elevate your branding with durable, vibrant labels designed for bottles of all shapes and sizes. Contact us today for fast and reliable bottle label printing!",
    keywords: "custom bottle labels, water bottle labels, wine bottle labels, beer labels, juice labels, waterproof labels, oil-resistant labels, freezer-safe labels, Pantone color matching, durable product labels, St Albans Digital Printing Inc.",
    link: "https://www.stalbansprinting.com/bottle_labels"
  },
  'business_cards': {
    title: "Queens Business Card Printing | Custom & Affordable Cards | St. Albans Digital Printing Inc.",
    description: "Get high-quality, custom business card printing in Queens, NY with St. Albans Digital Printing Inc. We offer premium finishes like foil stamping, embossing, matte, and gloss to create professional, standout business cards. Whether for networking, branding, or corporate use, our durable and affordable business cards are tailored to your needs. Order online or call now for fast printing services!",
    keywords: "Queens business card printing, custom business cards Queens, affordable business cards, premium business cards, embossed business cards, foil stamped business cards, matte business cards, glossy business cards, professional business cards, corporate business cards, networking cards, personalized business cards, Queens printing services, St Albans Digital Printing Inc.",
    link: "https://www.stalbansprinting.com/business_cards"
  },
  'carbonless_forms': {
    title: "Custom NCR Forms | Professional Carbonless Forms Printing | St. Albans Digital Printing Inc.",
    description: "Elevate your business with custom NCR forms for invoices, work orders, and proposals. Available in 2-Part, 3-Part, and 4-Part sets, featuring options like glued edges, sequential numbering, and padding. Order your professional carbonless forms online today!",
    keywords: "custom NCR forms, carbonless forms, professional printing, business forms printing, invoice booklets, work order forms, job order forms, proposals, multi-part forms, 2-part NCR forms, 3-part NCR forms, 4-part NCR forms, St. Albans Digital Printing, Queens printing services",
    link: "https://www.stalbansprinting.com/carbonless_forms"
  },
  'post_cards': {
    title: "Postcard Printing Company In Queens Ny | St. Albans Digital Printing Inc.",
    description: "Enhance your marketing efforts with custom postcard printing services from St. Albans Digital Printing Inc. We offer high-quality postcards ideal for direct mail campaigns, event promotions, and customer engagement. Designed to leave a lasting impression, our postcards feature vibrant colors and sharp details. Available in various sizes and finishes, we help you effectively communicate your message and boost your brand's visibility. Order online or visit us today!",
    keywords: "custom postcard printing, bulk postcard printing,direct mail postcards, promotional postcards, event invitation postcards, high-quality printing, fast postcard printing,branded postcards,affordable postcard printing,postcard printing cheap,St. Albans Digital Printing",
    link: "https://www.stalbansprinting.com/post_cards"
  },
  'flyers_8.5_x_11': {
    title: "Cheap Flyer Printing In New York| Custom Flyers for Marketing & Events | St. Albans Digital Printing Inc.",
    description: "Capture attention with premium-quality flyers from St. Albans Digital Printing. Our durable, glossy flyers are perfect for promoting events, products, and services. Designed to make a lasting impression, order now for vibrant graphics and exceptional quality!",
    keywords: "flyer printing, custom flyers, high-quality flyers, promotional flyers, event flyers, marketing materials, community event flyers, product launch flyers, service awareness flyers, medical flyers, business flyers, St. Albans printing services",
    link: "https://www.stalbansprinting.com/flyers_8.5_x_11"
  },
  'invitation_cards': {
    title: "Invitation Printing In Queens New York| St. Albans Digital Printing Inc.",
    description: "Transform your event into a memorable experience with custom invitations from St. Albans Digital Printing Inc. Our dedicated team crafts unique, stunning designs that reflect your personal style.",
    keywords: "custom invitations, personalized invitation design, hand-addressed envelopes, elegant calligraphy, stationery, business card printing, holiday cards, thank you notes, birth announcements, wedding invitations, party invitations, invitation printing services, St. Albans Digital Printing, custom stationery",
    link: "https://www.stalbansprinting.com/invitation_cards"
  },
  'notepad': {
    title: "Notepad Printing in New York| St. Albans Digital Printing Inc.",
    description: "Promote your brand effectively with custom printed notepads from St. Albans Digital Printing Inc. Ideal for conferences, trade events, and everyday office use, our high-quality notepads feature your logo and branding elements to enhance visibility. Available in various sizes and crafted with premium paper, these notepads are perfect for jotting down notes or making lists. Personalize your notepads today to leave a lasting impression on clients and colleagues!",
    keywords: "custom notepad printing, premium notepads, promotional notepads, branded notepads, NYC printing services, conference pads, personalized notepads, St. Albans Digital Printing",
    link: "https://www.stalbansprinting.com/notepad"
  },
  'roll_labels': {
    title: "Custom Roll Label Printing in Queens, NY | St. Albans Digital Printing Inc.",
    description: "Elevate your brand with high-quality custom roll labels from St. Albans Digital Printing in Queens, NY. We specialize in versatile and durable labels perfect for packaging and bottles. Our labels feature strong adhesives and are resistant to water and oils. Enjoy complete customization with various sizes, colors, and designs to meet your specific needs. Contact us today for exceptional service and fast turnaround!",
    keywords: "custom roll label printing, roll labels Queens NY, custom roll label,durable labels, waterproof labels, custom label design, high-quality printing, St. Albans Digital Printing, packaging labels, bottle labels",
    link: "https://www.stalbansprinting.com/roll_labels"
  },
  'vinyl_bumber_sticker': {
    title: "Vinyl Bumper Stickers Printing In Queens | St. Albans Digital Printing Inc.",
    description: "Make a statement with high-quality custom bumper stickers from St. Albans Digital Printing Inc. Our durable, waterproof, and fade-resistant vinyl stickers are designed to capture attention and promote your brand effectively. Perfect for businesses, social causes, and personal expression, our eye-catching designs ensure your message stands out on the road. Submit your ideas or let our creative team help you craft the perfect look. Order in bulk for cost-effective pricing and lasting impressions!",
    keywords: "custom bumper stickers, bumper sticker printing NYC, waterproof stickers, fade-resistant stickers, promotional stickers, vinyl bumper stickers, eye-catching designs, St. Albans Digital Printing",
    link: "https://www.stalbansprinting.com/vinyl_bumber_sticker"
  },
  'beverage_labels': {
    title: "Beverage Label Printers In Queens New York City| St. Albans Digital Printing Inc.",
    description: "Stand out on the shelves with high-quality custom beverage labels from St. Albans Digital Printing Inc. Our durable labels are designed for craft beer, wine, energy drinks, and juice bottles, ensuring vibrant branding that lasts. We offer fast turnaround, custom designs, and sustainable options to meet your needs. Trust us for compliance with industry standards and exceptional service tailored to New York's beverage market. Contact us today for a free quote!",
    keywords: "custom beverage labels, beverage label printing NYC, craft beer labels, wine labels, energy drink labels, juice bottle labels, waterproof beverage labels, fast turnaround printing, St. Albans Digital Printing Inc.",
    link: "https://www.stalbansprinting.com/beverage_labels"
  },
  'brouchers': {
    title: "Best Brochure Printers In Queens Ny  | St. Albans Digital Printing Inc.",
    description: "St. Albans Digital Printing Inc. is your premier choice for high-quality custom brochure printing in Queens, NY. We offer a variety of sizes and folding styles, including Tri-Fold, Bi-Fold, and Z-Fold brochures, using superior paper options for a professional finish. With swift turnaround times and affordable pricing, we cater to all your marketing needs—whether for corporate presentations or promotional materials. Contact us today to enhance your marketing efforts!",
    keywords: "brochure printing, custom brochures, Queens NY printing, Tri-Fold brochures, Bi-Fold brochures, Z-Fold brochures, marketing materials, St. Albans Digital Printing Inc., high-quality printing",
    link: "https://www.stalbansprinting.com/brouchers"
  },
  'calendar': {
    title: "Custom Calendar Printing in NYC | St. Albans Digital Printing Inc.",
    description: "Start the year right with personalized calendars from St. Albans Digital Printing Inc. Our high-quality 12 x 18-inch calendars are printed on durable 100 lb. gloss cover paper, featuring standard or high-gloss UV coating. Ideal for personal use or corporate gifts, our calendars blend functionality with elegance, showcasing cherished memories and important dates. Order online or visit us in Saint Albans, NY to create a unique calendar that reflects your style or brand identity!",
    keywords: "custom calendar printing, personalized calendars, NYC printing services, high-quality calendars, corporate gifts, photo calendars, 12-month calendars, St. Albans Digital Printing Inc.",
    link: "https://www.stalbansprinting.com/calendar"
  },
  'engg_prints': {
    title: "Engineering Prints In New York | St. Albans Digital Printing Inc.",
    description: "Unlock the power of precision with high-quality engineering prints and blueprints at St. Albans Digital Printing Inc. Serving architects, engineers, and construction professionals, we provide accurate reproductions of technical drawings and schematics using state-of-the-art printing technology. Our services include resizing, scanning, and binding to meet all your project needs. Visit us in Queens, NY for reliable and professional printing solutions!",
    keywords: "engineering prints, blueprints printing, technical drawings, St. Albans Digital Printing Inc., NYC printing services, architectural prints, construction blueprints, precision printing",
    link: "https://www.stalbansprinting.com/engg_prints"
  },
  'food_labels': {
    title: "Food Labels printing in New York city | St. Albans Digital Printing Inc.",
    description: "Stand out on the shelf with high-quality food and beverage label printing from St. Albans Digital Printing Inc. We specialize in custom labels for a variety of products, including baked goods, sauces, beverages, and more. Our labels are designed to withstand freezing, refrigeration, and moisture, ensuring durability and compliance with industry standards. Need same-day printing? No problem! Contact us today for expert solutions tailored to your needs!",
    keywords: "food label printing, beverage label printing, custom labels, nutrition labels, ingredient labels, waterproof labels, same day printing, St. Albans Digital Printing Inc., NYC printing services",
    link: "https://www.stalbansprinting.com/food_labels"
  },
  'letterheads': {
    title: "Letterheads Printing Services In New York | St. Albans Digital Printing Inc.",
    description: "Enhance your business branding with premium letterhead printing from St. Albans Digital Printing Inc. Our 28lb Hammermill Bright White & 24lb Ivory Linen letterheads can be customized with full-color or black ink flat printing to reflect your brand's personality. Enjoy fast turnaround times and eco-friendly printing solutions, whether you need a few sheets or a large batch. Contact us today to make a lasting impression with every piece of correspondence!",
    keywords: "letterhead printing, custom letterheads, professional stationery, NYC printing services, St. Albans Digital Printing Inc., fast turnaround letterhead",
    link: "https://www.stalbansprinting.com/letterheads"
  },
  'packaging_labels': {
    title: "Packaging Label Printers in USA | St. Albans Digital Printing Inc.",
    description: "Boost your product’s appeal with premium custom packaging labels from St. Albans Digital Printing Inc. Specializing in durable, moisture-resistant labels for food, beverages, and more, we ensure your packaging stands out. With over 30 years of expertise, we offer fast turnaround times, including same-day printing, and a wide range of materials to suit your needs. Reach out today for personalized solutions that enhance your brand’s visibility!",
    keywords: "packaging label printing, custom labels, food packaging labels, beverage labels, waterproof labels, same day printing, St. Albans Digital Printing Inc., NYC printing services",
    link: "https://www.stalbansprinting.com/packaging_labels"
  },
  'presentation_folders': {
    title: "Custom Folders Printing in NYC | St. Albans Digital Printing Inc.",
    description: "Organize your documents with high-quality custom presentation folders from St. Albans Digital Printing Inc. Our 9x12 folders feature full-color printing on the front and back with a high gloss UV finish, perfect for meetings, presentations, and events. Make a lasting impression with our durable and stylish folders. Contact us today or visit our location in St. Albans, NY for expert printing solutions!",
    keywords: "presentation folders, custom presentation folders, folder printing, NYC printing services, St. Albans Digital Printing Inc.,creative packaging, document organization,Office Supply Store New York",
    link: "https://www.stalbansprinting.com/presentation_folders"
  },
  'round_stickers': {
    title: "Custom Round Stickers Printing in NYC | St. Albans Digital Printing Inc.",
    description: "Introducing our custom round stickers, the perfect choice for showcasing your brand with stunning clarity and vibrant colors. Available in various sizes and durable materials, including vinyl and anodized aluminum, our stickers are precision-cut for a professional finish. Ideal for branding, marketing campaigns, event promotions, and personal use, they are resistant to water and UV rays. Order today to explore endless customization possibilities!",
    keywords: "custom round stickers, round sticker printing, durable vinyl stickers, anodized aluminum stickers,branding stickers, NYC printing services, St. Albans Digital Printing Inc., precision-cut stickers",
    link: "https://www.stalbansprinting.com/round_stickers"
  },
  'booklets': {
    title: "Professional Booklet Printing Services | St. Albans Digital Printing Inc.",
    description: "Showcase your business with professionally printed booklets from St. Albans Digital Printing Inc. Choose from 8.5x11 or 5.5x8.5 sizes, glossy or matte paper, and flexible quantities starting from 25. Ideal for product catalogs, restaurant menus, event programs, & marketing materials. Boost brand visibility with our easy-to-design templates & various binding options! Get started today.",
    keywords: "booklet printing, booklet printing services, product catalogs, restaurant menus, marketing materials, 8.5x11 booklets, 5.5x8.5 booklets, glossy booklets, matte booklets, NYC printing services, St. Albans Digital Printing Inc.",
    link: "https://www.stalbansprinting.com/booklets"
  },
  'digital_&_offset_printing': {
    title: "High-Quality Digital & Offset Printing in NYC | St. Albans Digital Printing Inc.",
    description: "Get exceptional quality & cost-effective printing solutions in NYC! St. Albans Digital Printing offers expert digital & offset services for marketing materials, stationery, and more. Benefit from fast turnaround, on-demand printing & expert advice. Contact us for a custom quote today!",
    keywords: "digital printing, offset printing, traditional printing, commercial printing, high-quality printing, NYC printing services, St. Albans Digital Printing Inc., marketing materials, corporate stationery, on-demand printing",
    link: "https://www.stalbansprinting.com/digital_&_offset_printing"
  },
  'newsletters': {
    title: "Best Newsletter Printing New York| Newsletter Services New York| St. Albans Digital Printing Inc.",
    description: "Engage customers with high-end printed newsletters from St. Albans Printing! We offer digital printing for flexible quantities & fast turnaround, plus various paper stocks & binding options . Ideal for HR, non-profits, & more. Get a quote today!",
    keywords: "newsletter printing, NYC printing services, digital printing, brochure folds, high-quality printing, St. Albans Printing, business newsletters, non-profit newsletters, HR newsletters, marketing materials",
    link: "https://www.stalbansprinting.com/newsletters"
  },
  'signs': {
    title: "Custom Vinyl Signs & Graphics in NYC | St. Albans Digiatl Printing Inc.",
    description: "Elevate your brand with custom vinyl signs & graphics from St. Albans Printing in NYC! We offer banners, window clings & more. High-quality printing, fast turnaround & expert design. Get a free consultation!",
    keywords: "vinyl signs, vinyl graphics, banners, window clings, vinyl printing,NYC printing services, sign company, St. Albans Digital Printing, custom signs, large format printing",
    link: "https://www.stalbansprinting.com/signs"
  },
  'catalogs': {
    title: "Catalogue Printing In Queens | St. Albans Digital Printing Inc.",
    description: "Showcase your products with stunning, full-color catalogs from St. Albans Printing. Our digital print experts transform your designs into polished marketing materials. Get high-quality inks, papers, binding, and finishing in NYC. Request a quote today!",
    keywords: "catalog printing, digital printing, brochure printing, marketing materials, full-color catalogs, high-quality printing, NYC printing services, St. Albans Digital Printing, custom catalogs",
    link: "https://www.stalbansprinting.com/catalogs"
  },
  'document_scanning': {
    title: "Document Scanning Services Nyc | St. Albans Digital Printing Inc.",
    description: "Digitize your documents with St. Albans Printing! Save space & money with our bulk, large-format, & medical record scanning services. Fast, secure & high-quality. Get a quote!  call 718-528-5100",
    keywords: "document scanning, bulk scanning, large format scanning, medical records scanning, legal document scanning, book scanning, digital archiving, document management, NYC scanning services, Queens NY, St. Albans Printing, 718-528-5100",
    link: "https://www.stalbansprinting.com/document_scanning"
  },
  'journals': {
    title: "Custom Journal Printing Services NYC | St. Albans Digital Printing Inc",
    description: "Design your own custom journal at St. Albans Digital Printing! Personalized notebooks,calendar, diaries, yearbooks & more. High-quality & fast turnaround in NYC. Call now! 718-528-5100",
    keywords: "journal printing, custom journals, personalized notebooks, planners, diaries, travel logs, themed notebooks, school yearbooks, event journals, fundraising journals, NYC printing, St. Albans Digital Printing Inc",
    link: "https://www.stalbansprinting.com/journals"
  },
  'photo_restoration': {
    title: "Photo Restoration Services NYC | St. Albans Digital Printing Inc",
    description: "Restore your cherished memories with St. Albans Digital Printing's expert photo restoration services in NYC. Repair damage, enhance color, and preserve your photos for generations! Call 718-528-5100",
    keywords: "photo restoration, photo repair, image restoration, vintage photo restoration, color correction, tear repair, crease repair, photo enhancement, water damage repair, photo retouching, digital archiving, photo printing, St. Albans Digital Printing, NYC, Queens",
    link: "https://www.stalbansprinting.com/photo_restoration"
  },
  'graphic_designing': {
    title: "The Best Graphic Design Company In New York | St. Albans Digital Printing Inc",
    description: "Get high-quality, custom graphic designs with unlimited revisions & a fast turnaround from St. Albans Printing in NYC! Web design, logos, marketing & more. Contact us for a free consultation!  718-528-5100",
    keywords: "unlimited graphic design, graphic design services, web design, logo design, branding, marketing design, NYC graphic design, St. Albans Digital Printing,affordable design, Queens graphic design, small business design",
    link: "https://www.stalbansprinting.com/create_designs"
  },
  'logo_designing': {
    title: "Logo Design Agency In Usa | St. Albans Digital Printing Inc",
    description: "Craft a compelling brand with custom logo design services from St. Albans Printing in NYC. Get sleek, modern & unique logos that resonate with your audience. Web design & marketing services available. Call us today! 718-528-5100",
    keywords: "logo design, custom logo design, logo design services, professional logo design, unique logo design, brand identity, web design, digital marketing, NYC logo design, St. Albans Digital Printing, affordable logo design, 718-528-5100",
    link: "https://www.stalbansprinting.com/logo_designing"
  },
  'large_envelopes': {
    title: "Envelope Printing in NYC |St. Albans Digital Printing Inc",
    description: "Stand out with custom envelopes from St. Albans Printing in NYC! High-quality 9x12 & 10x13 sizes, 24lb & 28lb paper options (White Wove, Brown Kraft). Perfect for business & personal mail. Call 718-528-5100!",
    keywords: "envelope printing, custom envelopes, large envelopes, 9x12 envelopes, 10x13 envelopes, business envelopes, personalized envelopes, NYC printing services, St. Albans Printing",
    link: "https://www.stalbansprinting.com/large_envelopes"
  },
  'mail_postcards': {
    title: "EDDM Postcard Printing Services | St. Albans Digital Printing Inc.",
    description: "Enhance your marketing with Every Door Direct Mail (EDDM) postcard printing service in Queens. We specialize in designing and printing custom postcards that can be targeted to your ideal audience based on factors like income, age, household size, and location. Our expert team at St. Albans Digital Printing Inc. provides comprehensive EDDM printing solutions, ensuring your postcards are professionally designed and printed for effective delivery to the right customers.",
    keywords: "EDDM postcard printing, Every Door Direct Mail, targeted direct mail, custom postcards, Queens EDDM services, postcard advertising, affordable EDDM printing, direct mail postcards,EDDM flyer printing, EDDM postage, Queens printing services, marketing postcards, promotional postcards",
    link: "https://www.stalbansprinting.com/mail_postcards"
  },
  'labels_/_stickers': {
    title: "Custom Sticker Printing Services in NYC| St. Albans Digital Printing Inc.",
    description: "St. Albans Digital Printing Inc. offers custom sticker printing services in NYC, providing high-quality, durable stickers for marketing, branding, packaging, and more. We offer a wide variety of sizes, shapes, and finishes, including UV-coated, bumper, die-cut, and foil stickers. Whether you need stickers for business promotions, gifts, or office decoration, our expert designers are here to bring your vision to life. Get affordable, top-notch sticker printing today!",
    keywords: "custom stickers, sticker printing NYC, premium stickers, bumper stickers, die-cut stickers, UV-coated stickers, custom logo stickers, promotional stickers, foil stickers, affordable sticker printing, St. Albans Digital Printing Inc, sticker printing services",
    link: "https://www.stalbansprinting.com/labels_/_stickers"
  },
  'website_designing': {
    title: "Website Design Company  New York | St. Albans Digital Printing Inc.",
    description: "St. Albans Digital Printing Inc. provides custom website design, website development, and mobile app development services in NYC. From small businesses to large enterprises, we offer tailored solutions, including custom software development and Websites at affordable prices. Our team ensures your website and apps are designed and developed to your exact specifications with full support and hosting options. Let us bring your ideas to life with professional design and development services.",
    keywords: "custom website design, website development, mobile app development, custom software solutions, website hosting, professional website services, small business website design, app development, web support, branding, logo design, marketing strategies, website maintenance, New York City web development",
    link: "https://www.stalbansprinting.com/website_designing"
  },
  'additional_booklets': {
    title: "Additional Booklet Printing Services | St. Albans Digital Printing Inc.",
    description: "St. Albans Digital Printing Inc. offers additional booklet printing services, providing flexible quantities and customization options. Whether you need more copies of your product catalog, event program, or marketing materials, we ensure high-quality prints with various sizes, finishes, and binding styles. Ideal for expanding your print materials, our additional booklet services offer convenience and affordability. Contact us today to reorder or customize your next booklet!",
    keywords: "additional booklet printing, booklet reprints, custom booklet printing, reprint product catalogs, event program reprints, marketing material booklets, flexible booklet quantities, St. Albans Digital Printing Inc, NYC booklet printing services, booklet customization",
    link: "https://www.stalbansprinting.com/additional_booklets"
  },
};

